import React from 'react';
import service1 from '../assets/images/service1.png';
import service2 from '../assets/images/service2.png';
import service3 from '../assets/images/service3.png';

const Services = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      <h1 style={{ fontSize: '36px', color: '#22225f' }}>Our Services</h1>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap', marginTop: '20px' }}>
        {/* Business Loans */}
        <a
          href="/services/business-loans"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            width: '300px',
            textAlign: 'center',
            border: '1px solid #ddd',
            borderRadius: '10px',
            padding: '15px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            transition: 'transform 0.2s',
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
          onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          <img src={service1} alt="Business Loans" style={{ width: '100%', borderRadius: '10px' }} />
          <h3 style={{ fontSize: '20px', margin: '10px 0', color: '#22225f' }}>Business Loans</h3>
          <p>Flexible financing to grow and scale your business effectively.</p>
        </a>

        {/* Overdraft Facilities */}
        <a
          href="/services/overdraft-facilities"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            width: '300px',
            textAlign: 'center',
            border: '1px solid #ddd',
            borderRadius: '10px',
            padding: '15px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            transition: 'transform 0.2s',
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
          onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          <img src={service2} alt="Overdraft Facilities" style={{ width: '100%', borderRadius: '10px' }} />
          <h3 style={{ fontSize: '20px', margin: '10px 0', color: '#22225f' }}>Overdraft Facilities</h3>
          <p>Seamless access to credit for your operational needs.</p>
        </a>

        {/* Government-Backed Schemes */}
        <a
          href="/services/government-backed-schemes"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: 'none',
            color: 'inherit',
            width: '300px',
            textAlign: 'center',
            border: '1px solid #ddd',
            borderRadius: '10px',
            padding: '15px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            transition: 'transform 0.2s',
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
          onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          <img src={service3} alt="Government-Backed Schemes" style={{ width: '100%', borderRadius: '10px' }} />
          <h3 style={{ fontSize: '20px', margin: '10px 0', color: '#22225f' }}>Government-Backed Schemes</h3>
          <p>Avail affordable loans under Mudra, CGTMSE, and more.</p>
        </a>
      </div>

      {/* Floating WhatsApp Chat Button */}
      <a
        href="https://wa.me/917569523497?text=Hello!%20I%20would%20like%20to%20know%20more%20about%20your%20services."
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          backgroundColor: '#25d366',
          borderRadius: '50%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          style={{ width: '40px', height: '40px' }}
        />
      </a>
    </div>
  );
};

export default Services;
